import React from 'react'
import { cn } from '@/lib/utils'
import { useRouter, useTabSwitch } from '../../hooks'
import { useModuleActions } from '../../hooks/useMyPermissions'
import { Nav, NavLink, NavItem, TabContent, TabPane } from '@/components/ui-compat'
import { useTranslation } from 'react-i18next'
import { List, Map, Settings } from 'lucide-react'

import SnagsList from './components/SnagsList'
import SnagsSettings from './components/SnagsSettings'
import BlueprintView from './components/blueprint/BlueprintView'

export default () => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useTabSwitch('list')
  const {
    query: { projectId },
  } = useRouter() as { query: { projectId?: string } }
  // Snag settings (buildings, floors, categories) are a management surface —
  // only roles with ISSUES.ADMIN see the tab (restricted roles like
  // subcontractor-snags-only keep List/Blueprint).
  const { canAdmin } = useModuleActions('ISSUES', projectId)
  const effectiveTab = activeTab === 'settings' && !canAdmin ? 'list' : activeTab

  return (
    <div className="snags-module">
      {/* Page Header */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold mb-0">{t('Snags_screen_snags_label')}</h1>
      </div>

      {/* Navigation Tabs */}
      <div className="tab">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={cn('flex items-center', { active: effectiveTab === 'list' })}
              onClick={() => setActiveTab('list')}
            >
              <List className="h-4 w-4 mr-2" />
              {t('Snags_list_tablabel')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={cn('flex items-center', { active: effectiveTab === 'blueprint' })}
              onClick={() => setActiveTab('blueprint')}
            >
              <Map className="h-4 w-4 mr-2" />
              {t('Snags_blueprint_tablabel')}
            </NavLink>
          </NavItem>
          {canAdmin && (
            <NavItem>
              <NavLink
                className={cn('flex items-center', { active: effectiveTab === 'settings' })}
                onClick={() => setActiveTab('settings')}
              >
                <Settings className="h-4 w-4 mr-2" />
                {t('Snags_settings_tablabel')}
              </NavLink>
            </NavItem>
          )}
        </Nav>

        <TabContent activeTab={effectiveTab}>
          <TabPane tabId="list">
            <SnagsList />
          </TabPane>
          <TabPane tabId="blueprint">
            <BlueprintView />
          </TabPane>
          {canAdmin && (
            <TabPane tabId="settings">
              <SnagsSettings />
            </TabPane>
          )}
        </TabContent>
      </div>
    </div>
  )
}
